import { Typography } from "antd";
import useResponsive from "../../../utils/hooks/useResponsive";

const TextFee = ({ title, value }: { title: string; value: string }) => {
  const { isTablet } = useResponsive();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        gap: 10,
      }}
    >
      <Typography
        style={{
          fontSize: isTablet ? 14 : 16,
          fontWeight: 400,
          color: "white",
          minWidth: "150px",
        }}
      >
        {title}
      </Typography>
      <Typography
        style={{
          fontSize: isTablet ? 14 : 16,
          fontWeight: 500,
          color: "white",
        }}
      >
        {value}
      </Typography>
    </div>
  );
};

export default TextFee;
